import qs from "query-string"
import { trackEvent } from "./common"
import Source from "../interview/Source"

const employerCapture = {
  init: () => trackEvent("Employer capture - Intro question asked"),
  optIn: () => trackEvent("Employer capture - Intro question answered Yes"),
  introOptOut: response =>
    trackEvent("Employer capture - Intro opt-out", { response }, false),
  inputOptOut: () => trackEvent("Employer capture - Input opt-out"),
  employerProvided: () => trackEvent("Employer capture - Employer given"),
}

const insuranceCapture = {
  init: () => trackEvent("Insurance capture - Question asked"),
  submitProvider: carrier => trackEvent(`Carrier - ${carrier}`),
}

const tracker = {
  pageLoaded: () => {
    const query = qs.parse(window.location.search)
    trackEvent("Product page loaded", { from: query.from })
  },

  startPageTracker: () => {
    trackEvent("Interview - Started")
    Source.interviewEventTracker("Interview - Started")
  },

  over13: () => trackEvent("Consent - Over 13"),
  under13: () => trackEvent("Consent - Under 13"),

  pov: () => {
    trackEvent("Identifier - POV")
    Source.interviewEventTracker("Identifier - POV")
  },
  sex: () => {
    trackEvent("Identifier - sex")
    Source.interviewEventTracker("Identifier - sex")
  },
  age: () => {
    trackEvent("Identifier - age")
    Source.interviewEventTracker("Identifier - age")
  },
  profile: () => trackEvent("Identifier - name", { event: "profile" }),
  name: () => trackEvent("Identifier - name"),

  clarifierGiven: () => trackEvent("Clarifier - clarifiers given"),
  editSubmission: () => trackEvent("Interview - edit submission"),
  skipQuestion: () => trackEvent("Interview - skipped question"),
  clarifierSubmitted: () => trackEvent("Clarifier - clarifier submitted"),
  answer: () => {
    trackEvent("Interview - question answered")
    Source.interviewEventTracker("Interview - question answered")
  },
  media: () => trackEvent("Interview - question with media instruction"),
  pictureOptions: () => trackEvent("Interview - question with picture options"),
  clarifierImages: () => trackEvent("Clarifier - option images given"),
  submitFilter: () => trackEvent("Filter - submitted"),
  servedFilter: () => trackEvent("Filter - served"),
  interviewStarted: () => {
    trackEvent("Interview - started")
    Source.interviewEventTracker("Interview - I'm done adding symptoms")
  },
  algoStarted: () => trackEvent("Interview - algo started"),

  dxocSearchShown: () => {
    trackEvent("DXoC search bar - shown", {}, false)
    Source.interviewEventTracker("DXoC search bar - shown")
  },
  dxocSearchClickedOnSearchBar: () => {
    trackEvent("DXoC search bar - clicked on search bar", {}, false)
    Source.interviewEventTracker("DXoC search bar - clicked on search bar")
  },
  dxocSearchCancel: () => {
    trackEvent("DXoC search bar - cancel", {}, false)
    Source.interviewEventTracker("DXoC search bar - cancel")
    Source.interviewEventTracker("DXoC complete")
  },
  dxocSearchSkip: () => {
    trackEvent("DXoC search bar - skip", {}, false)
    Source.interviewEventTracker("DXoC search bar - skip")
    Source.interviewEventTracker("DXoC complete")
  },
  dxocSearchAttempted: () => {
    trackEvent("DXoC search bar - search attempted", {}, false)
    Source.interviewEventTracker("DXoC search bar - search attempted")
  },
  dxocSearchClickedOnSuggestion: () => {
    trackEvent("DXoC search bar - clicked on suggestion", {}, false)
    Source.interviewEventTracker("DXoC search bar - clicked on suggestion")
    Source.interviewEventTracker("DXoC complete")
  },
  dxocClose: dxoc => {
    trackEvent(`DXoC Denied - ${dxoc}`)
  },

  searchAttempted: () => {
    trackEvent("Search bar - search attempted")
    Source.interviewEventTracker("Search bar - search attempted")
  },
  lookingAtSuggestions: count => {
    trackEvent("Search bar - looking at suggestions", {
      "Suggestion count": count,
    })
  },
  editSearch: () => trackEvent("Search bar - edit submission"),
  searchClicked: () => {
    trackEvent("Search bar - click on search bar")
    Source.interviewEventTracker("Search bar - click on search bar")
  },
  suggestionClicked: () => {
    trackEvent("Search bar - clicked on a search suggestion")
    Source.interviewEventTracker("Search bar - clicked on a search suggestion")
  },
  suggestionMissing: () =>
    trackEvent("Search bar - missing desired suggestion"),
  clarifierClicked: () => {
    trackEvent("Search bar - clicked on a clarifier suggestion")
    Source.interviewEventTracker(
      "Search bar - clicked on a clarifier suggestion"
    )
  },

  genericCrash: () => trackEvent("Crash", { type: "Generic" }),
  longLoad: () => trackEvent("Long Loading"),
  startOver: () => trackEvent("Startover clicked"),

  newUser: () => trackEvent("New user - activated Beta"),
  activation: () => trackEvent("Activation page loaded"),
  loginLoaded: () => trackEvent("Login page loaded"),
  resetLoaded: () => trackEvent("Landing page loaded", { type: "reset" }),
  waitlistLoaded: () => trackEvent("Waitlist page loaded"),
  signupLoaded: () => trackEvent("Landing page loaded", { type: "signup" }),
  emailSubmitted: () => trackEvent("Signup - Email submitted"),
  emailGiven: () => trackEvent("Email given"),
  emailSkipped: () => trackEvent("Email skipped"),
  saveResultsClicked: () => trackEvent("Save results clicked"),

  completion: (count, alarm) => {
    let result = ""

    if (alarm) {
      result = "alarms"
    } else if (count === 0) {
      result = "noResult"
    } else {
      result = "reached"
    }

    trackEvent(`Completion - ${result}`)
    Source.interviewEventTracker(`Completion - ${result}`)

    trackEvent("Interview - Completed")
    Source.interviewEventTracker("Interview - Completed")
  },

  rating: rating => trackEvent("net rating given", { rating }, false),
  ratingReason: option =>
    trackEvent("net rating unsatisfactory reason", { option }, false),
  share: (source, type) =>
    trackEvent("Share button clicked", { source, type }, false),

  flagItem: () => trackEvent("Flagged item"),
  explainClick: () => trackEvent("Question explanation clicked."),

  wantsToConnect: () => trackEvent("User wants to connect with providers"),
  askedForLocation: () => trackEvent("User was asked for a location"),
  askedForMembership: () => trackEvent("User was asked for membership"),
  shownRecommendation: (
    marketplaceToken,
    recommendationName,
    recommendationToken
  ) => {
    trackEvent(
      "Recommendation - Impression",
      { marketplaceToken, recommendationName, recommendationToken },
      false
    )
  },
  recommendationUserAction: (
    recommendationName,
    recommendationToken,
    clinicDialed
  ) => {
    trackEvent(
      "Recommendation - Clicked",
      { recommendationName, recommendationToken, clinicDialed },
      false
    )
  },
  completionEmailGiven: () => trackEvent("Completion - Email Given"),
  embeddedEmailGiven: () => trackEvent("Embedded Email Given"),
  embeddedEmailSkipped: () => trackEvent("Embedded Email Skipped"),

  diagnosisConfirmed: () => trackEvent("Completion - I agree with result"),
  diagnosisDenied: () => trackEvent("Completion - I disagree with result"),

  helpfulnessConfirmed: () => trackEvent("Completion - Result was Helpful"),
  helpfulnessDenied: () => trackEvent("Completion - Result was NOT Helpful"),

  userTaggingSubmitted: () => trackEvent("User tagging - all submitted"),
  contactInfoQuestionShown: () =>
    trackEvent("Completion - contact info question shown"),

  userFindingCare: () => trackEvent("User Intent - User is seeking care."),
  userCheckingSymptoms: () =>
    trackEvent("User Intent - User is checking symptoms."),
  intentQuestionAnswered: () => {
    trackEvent("User Intent - User has answered the user intent question.")
    Source.interviewEventTracker(
      "User Intent - User has answered the user intent question."
    )
  },

  followUpModalTriggered: () => {
    trackEvent("Follow Up - User has clicked on CTA.")
    Source.interviewEventTracker("Follow Up - User has clicked on CTA.")
  },

  followUpAnswered: () => {
    trackEvent("Follow Up - User has answered follow up.")
    Source.interviewEventTracker("Follow Up - User has answered follow up.")
  },

  npsResponseGiven: () => trackEvent("NPS-Response-Given"),
  npsPromoters: () => trackEvent("NPS-Promoters"),
  npsDetractors: () => trackEvent("NPS-Detractors"),
  npsPassives: () => trackEvent("NPS-Passives"),
  npsComplete: () => trackEvent("NPS-Complete"),

  paymentAccountPageLoaded: () => trackEvent("Payment - Account page loaded"),
  paymentCardPageLoaded: () => trackEvent("Payment - Card info page loaded"),
  paymentSubmitPageLoaded: () =>
    trackEvent("Payment - Confirmation page loaded"),

  tipModalShowed: () => trackEvent("Tip - Modal showed"),
  tipSuccessful: amount => trackEvent("Tip - Successful", { amount }, false),
  tipError: reason => trackEvent("Tip - Tried but failed", { reason }, false),

  apiResponseTime: (url, responseTime, visitToken) =>
    trackEvent("API Response Time", { url, responseTime, visitToken }, false),

  postIntentPopUpShown: () => trackEvent("Post Intent - Shown", {}, false),

  postIntentPopUpResponse: (response, leftComment) =>
    trackEvent("Post Intent - Response", { response, leftComment }, false),

  locationTimeout: () => trackEvent("Location timeout"),

  thisIsConfusing: () => trackEvent("This is confusing", {}, false),
  showGinaModal: () => trackEvent("GINA Modal - Shown", {}, false),
  acceptGinaTerms: () => {
    trackEvent("GINA Modal - Accepted")
    Source.interviewEventTracker("GINA Modal - Accepted")
  },

  employerCapture,
  insuranceCapture,
}

export { tracker as default }



// WEBPACK FOOTER //
// ./assets/common/tracker.js